import { message, userform } from '../locale'

// 校验手机号输入
const validatePhone = function(phone) {
  let result = { error: true, correct: phone }
  if (!phone) {
    result.text = message.content.input.replace('%', userform.field.mobile)
  } else if (/\t/.test(phone)) {
    result.text = userform.hint.mobile.repeat
    result.correct = phone.replace(/\t/, '')
  } else if (!/^1[34578]\d{9}$/.test(phone)) {
    result.text = message.content.disformat.replace('%', userform.field.mobile)
  } else {
    result.error = false
  }
  return result
}

// 校验密码输入
const validatePassword = function(password, password2, password3) {
  let result = { error: true, error2: true }
  if (!password) {
    result.text = message.content.input.replace('%', userform.field.password)
  } else if (!(typeof password2 == 'boolean' && password2) && !/^\S{6,16}$/.test(password)) {
    result.text = userform.hint.password.over
  } else {
    result.error = false
  }
  if (!password2 && result.error) {
    result.error2 = false
    return result
  }
  if (!password2) {
    result.text2 = userform.hint.password.confirm
  } else if (typeof password3 == 'boolean' && !password3 && !/^\S{6,16}$/.test(password2)) {
    result.text2 = userform.hint.password.over
  } else if (typeof password2 == 'string' && password2 != password) {
    result.text2 = userform.hint.password.diff
  } else {
    result.error2 = false
  }
  return result
}

export {
  validatePhone,
  validatePassword
}



// WEBPACK FOOTER //
// ./src/commons/utils/login.js